/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, Inject, Renderer2, ElementRef, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavbarService } from '../../../_services/navbar.service';
import { ThemeSettingsService } from '../../settings/theme-settings.service';
import { MenuSettingsService } from '../../settings/menu-settings.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/_services/auth.service';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { AppConstants } from 'src/app/_helpers/app.constants';
import { ThemeSettingsConfig } from '../../../model/themeSettingsConfig.module';
import { Product } from '../../../model/product.model';
import { ProductService } from '../../../_services/domainservice/product.service';
import { ClientRegistration } from '../../../model/client.model';
import { ClientService } from '../../../_services/domainservice/Client.service';
import { Guid } from '../../../_helpers/guid';
import { MenuService } from '../../../_services/domainservice/menu.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertService } from '../../../_services/alert.service';
//import { VerticalnavComponent } from '../../navigation/verticalnav/verticalnav.component';
import { Account } from '../../../model/account.model';
import { AccountService } from '../../../_services/domainservice/account.service';
import { CoreGymService } from '../../../_services/core.gym.service.service';
import { environment } from '../../../../environments/environment';
//import { NotificationCenterModule } from '@novu/notification-center-angular';
import { NotificationService } from '../../../_services/domainservice/notification.service';
import { Notification } from '../../../model/notification.model';
import { SharedComponent } from '../../../../shared/shared.component';
import { NgxSpinnerService } from 'ngx-spinner';



//declare function initializeNotifications(target: HTMLElement, userEmail: string);


// const docElmWithBrowsersFullScreenFunctions = document.documentElement as HTMLElement & {
//   mozRequestFullScreen(): Promise<void>;
//   webkitRequestFullscreen(): Promise<void>;
//   msRequestFullscreen(): Promise<void>;
// };

// const docWithBrowsersExitFunctions = document as Document & {
//   mozCancelFullScreen(): Promise<void>;
//   webkitExitFullscreen(): Promise<void>;
//   msExitFullscreen(): Promise<void>;
// };

interface MenuSettingsConfig {
  vertical_menu: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    items: any[];
  };
}
@Component({
  selector: 'app-header-vertical',
  templateUrl: './vertical.component.html',
  styleUrls: ['./vertical.component.css']
})
export class VerticalComponent extends SharedComponent implements OnInit, AfterViewInit {
  insideTm: ReturnType<typeof setTimeout>;
  outsideTm: ReturnType<typeof setTimeout>;
  //private _unsubscribeAll: Subject<any>;
  //private _unsubscribeAllMenu: Subject<any>;
  public _themeSettingsConfig: ThemeSettingsConfig;
  private _menuSettingsConfig: MenuSettingsConfig;
  public selectedHeaderNavBarClass: string;
  public selectedNavBarHeaderClass: string;
  public currentUser: ClientRegistration;
  public isHeaderSearchOpen: boolean;
  isMobile = false;
  showNavbar = false;
  public maximize: string;
  public search: string;
  public internationalization: string;
  public email: string;


  private _unsubscribeAll = new Subject<void>();
  private _unsubscribeAllMenu = new Subject<void>();
  public productuid: Guid;
  public selectedProductUId: Guid;
  public selectedClientUId: Guid;
  public selectedRoleBasedlogedin: Guid;
  public selectedLoggedinUId: Guid;
  public selectedemailid: string;
  public ProductDetailsList: Array<Product>;
  public Clientregistrationlist: Array<ClientRegistration>;
  public Clients: Array<ClientRegistration>;
  client: ClientRegistration = new ClientRegistration;
  public Accountlist: Array<Account>;
  public Notificationlist: Array<Notification>
  notifications: string;
  notification: Notification = new Notification;
  notificationuid: Guid;
  registrationUId: Guid;
  public count: number = 0;
  name: string;
  public config: PerfectScrollbarConfigInterface = { wheelPropagation: false };
  subscriberId = environment.subscriberId;
  applicationIdentifier = environment.applicationIdentifier;
  sessionLoaded = (data: unknown) => {
    console.log('loaded', { data });
  };

  showNotifications = false;
  //notifications = [
  //  'Notification 1',
  //  'Notification 2',
  //  'Notification 3',
  //  'Notification 4'
  //];
  styles = {
    bellButton: {
      root: {
        svg: {
          color: 'white',
          width: '25px',
          height: '20px',
          fill: 'white',
        },
      },
      dot: {
        rect: {
          fill: 'rgb(221, 0, 49)',
          strokeWidth: '0.2',
          stroke: 'white',
          width: '3.5px',
          height: '3.5px',
        },
        left: '40%',
      },
    },
    header: {
      root: {
        backgroundColor: '',
        '&:hover': { backgroundColor: '' },
        '.some_class': { color: '' },
      },
    },
    layout: {
      root: {
        backgroundColor: '',
      },
    },
    popover: {
      arrow: {
        backgroundColor: '',
        border: '',
      },
    },
  };
  
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  //@ViewChild(VerticalnavComponent) verticalnavComponent?: VerticalnavComponent;
  @ViewChild(PerfectScrollbarDirective, { static: true }) directiveRef?: PerfectScrollbarDirective;
  //@ViewChild('notificationsInbox') notificationsInbox: ElementRef;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private _renderer: Renderer2,
    private navbarService: NavbarService,
    private _themeSettingsService: ThemeSettingsService,
    private _menuSettingsService: MenuSettingsService,
    public authService: AuthService,
    private router: Router,
    private elementRef: ElementRef,
    private productService: ProductService,
    private clientService: ClientService,
    private menuService: MenuService,
    private alertService: AlertService,
    private accountService: AccountService,
    private readonly coreGymService: CoreGymService,
    private notificationService: NotificationService,
    private spinner: NgxSpinnerService,
  ) {
   
    super()
    {
      this._unsubscribeAll = new Subject();
      this._unsubscribeAllMenu = new Subject();
    }
  }

  logout() {
    if (localStorage.getItem('currentUser')) {
      this.authService.doLogout().then(() => {
        window.location.href = '/';
      }, err => {
        console.log(err);
      });
    }
  }

  openfullscreen() {
    document.documentElement.requestFullscreen();
  }

  closefullscreen() {
    document.exitFullscreen();
  }

  toggleNotifications() {
    this.showNotifications = !this.showNotifications;
    this.selectedClientUId = localStorage.getItem('CurrentClientUId');
    this.selectedRoleBasedlogedin = localStorage.getItem('CurrentRoleBasedlogedin');
    this.notificationService.getNotification(this.selectedClientUId.toString(), this.selectedRoleBasedlogedin.toString()).subscribe((notificationdetails): void => {
      this.Notificationlist = notificationdetails;
      this.count = notificationdetails.length;
      if (this.count == 0) {
        this.alertService.info("Notification Not Found");
        this.showNotifications = !this.showNotifications;
      }
      else {
        for (let i = 0; i < notificationdetails.length; i++) {
          this.notificationuid = notificationdetails[i].notificationUId;
          this.notifications = this.Notificationlist[i].message;
          this.registrationUId = this.Notificationlist[i].gymRegistrationUId;
          this.notification.modifiedByApp = this.Notificationlist[i].modifiedByApp;
          this.notification.modifiedByUser = this.Notificationlist[i].modifiedByUser;
          this.name = this.Notificationlist[i].name;
          this.UpdateViewedNotification();
        }
      }
    })
  }
  UpdateViewedNotification()
  {
    this.notification.itemState = 2;
    this.notification.notificationUId = this.notificationuid;
    this.notification.message = this.notifications;
    this.notification.isViewed = true;
    this.notification.productUId = this.selectedProductUId;
    this.notification.gymRegistrationUId = this.registrationUId;
    this.notification.clientRegistrationUId = this.selectedClientUId;
    this.notification.roleBasedLogedin = this.selectedRoleBasedlogedin;
    this.notification.name = this.name;
    this.notification.createdByUser = this.notification.modifiedByUser;
    this.notification.createdByApp = this.notification.modifiedByApp;
    this.setAuditFields(this.notification);
    this.notificationService.mergeNotification(this.notification, 'Edit').subscribe((): void => {
    },
      (error: HttpErrorResponse): void => {
        console.log(error);
        this.alertService.error(error.message);
        this.spinner.hide();
      });
  }
  ResetPasswordPage()
  {
    this.router.navigate(['/authentication/resetpassword']);
  }

  onBellButtonClick() {
    console.log('Notification bell clicked!');
    this.showNotifications = true;
    // Add any other logic you want to execute on button click here
  }
  ngOnInit() {

    this.isMobile = window.innerWidth < AppConstants.MOBILE_RESPONSIVE_WIDTH;
    if (!this.isMobile) {
      this.showNavbar = true;
    }
    if (localStorage.getItem('currentUser')) {
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    }
    this.productuid = JSON.parse(localStorage.getItem('currentProduct')).productUId;
    this.productService.getProduct().subscribe((getProductUIdData: Array<Product>) => {
      this.clientService.getClient().subscribe((getClientRegistrationData: Array<ClientRegistration>) => {
        this.accountService.getAccount().subscribe((getaccount: Array<Account>) => {
          this.Accountlist = getaccount;
          this.Clientregistrationlist = getClientRegistrationData;
          this.ProductDetailsList = getProductUIdData;
          this.selectedProductUId = localStorage.getItem('CurrentProductUId');
          this.selectedClientUId = localStorage.getItem('CurrentClientUId');
          this.selectedRoleBasedlogedin = localStorage.getItem('CurrentRoleBasedlogedin');
          this.selectedLoggedinUId = localStorage.getItem('CurrentloggedInUId');
          this.selectedemailid = localStorage.getItem('EmailId');
          this.getProductMenu(localStorage.getItem('CurrentProductUId'));
        })
      });
    });
    this.selectedClientUId = localStorage.getItem('CurrentClientUId');
    this.selectedRoleBasedlogedin = localStorage.getItem('CurrentRoleBasedlogedin');
    this.notificationService.getNotification(this.selectedClientUId.toString(), this.selectedRoleBasedlogedin.toString()).subscribe((notificationdetails): void => {
      this.Notificationlist = notificationdetails;
      this.count = notificationdetails.length;
    });
    // Subscribe to config changes
    this._themeSettingsService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config) => {
        this._themeSettingsConfig = config;
        const logo = JSON.parse(localStorage.getItem('currentUser')).clientRegistration.logo
        this._themeSettingsConfig.brand.logo.value = logo != null && logo != '' ? this.coreGymService.BaseUrl + logo : 'assets/custom/images/abg/abglogoicon512.ico';
        this._themeSettingsConfig.brand.brand_name = JSON.parse(localStorage.getItem('currentUser')).clientRegistration.companyName;
        //}
        this.refreshView();
      });
    this._menuSettingsService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config) => {
        this._menuSettingsConfig = config;
      });
    this.maximize = this._themeSettingsConfig.headerIcons.maximize;
    this.search = this._themeSettingsConfig.headerIcons.search;
    this.internationalization = this._themeSettingsConfig.headerIcons.internationalization;
    //this.notification = this._themeSettingsConfig.headerIcons.notification;
    this.email = this._themeSettingsConfig.headerIcons.email;
   
  }

  ngAfterViewInit() {
    //let notificationsInboxHtmlElement = this.notificationsInbox.nativeElement as HTMLElement;
    //initializeNotifications(notificationsInboxHtmlElement, "kishore@gmail.com");
    this.refreshView();
  }
  GetClients(e) {
    this.setCurrentProductUId(e.target.value);
    this.getProductMenu(e.target.value)
  }

  getProductMenu(productUId) {
    this.menuService.getMenuProduct(productUId, localStorage.getItem('CurrentRoleBasedlogedin')).subscribe((data): void => {
      this.menuService.setmenu(data);
      this.redirectLogin(data);
    },
      (error: HttpErrorResponse): void => {
        console.log(error);
        this.alertService.error(error.message);
      }
    );
    this.Clients = this.Clientregistrationlist.filter(s => s.productUId == productUId);
  }
  redirectLogin(UserDetails) {
    localStorage.removeItem('currentLayoutStyle');
    UserDetails = UserDetails.sort(function (a, b) {
      return a.displayOrder - b.displayOrder;
    });
    const returnUrl = UserDetails[0].page;// '/dashboard/gym';
    //if (this.returnUrl) {
    //  returnUrl = this.returnUrl;
    //}
    //this.alertService.success("Welcome!");
    this.router.navigate([returnUrl]);
  }
  onOptionsSelected(e) {
    console.log(e.target.value)
    this.setCurrentClientUId(e.target.value);
    location.reload();
  }

  refreshView() {
    const iconElement = document.getElementsByClassName('toggle-icon');
    const menuColorElement = document.getElementsByClassName('main-menu');
    const navigationElement = document.getElementsByClassName('main-menu');
    const navbarElement = document.getElementsByClassName('header-navbar');
    const themeColorElement = document.getElementsByClassName('header-navbar');
    //const element = document.getElementsByClassName('navbar-header');
    //onst boxelement = document.getElementById('customizer');
    if (iconElement) {
      if (this._themeSettingsConfig.colorTheme === 'semi-light' || this._themeSettingsConfig.colorTheme === 'light') {
        this._renderer.removeClass(iconElement.item(0), 'white');
        this._renderer.addClass(iconElement.item(0), 'blue-grey');
        this._renderer.addClass(iconElement.item(0), 'darken-3');
      } else if (this._themeSettingsConfig.colorTheme === 'semi-dark' || this._themeSettingsConfig.colorTheme === 'dark') {
        this._renderer.addClass(iconElement.item(0), 'white');
        this._renderer.removeClass(iconElement.item(0), 'blue-grey');
        this._renderer.removeClass(iconElement.item(0), 'darken-3');
      }
    }

    if (this._themeSettingsConfig.colorTheme === 'semi-light') {
      this.selectedHeaderNavBarClass = this._themeSettingsConfig.menuColor;
      this.selectedNavBarHeaderClass = '';
    } else if (this._themeSettingsConfig.colorTheme === 'semi-dark') {
      this.selectedNavBarHeaderClass = this._themeSettingsConfig.menuColor;
      this.selectedHeaderNavBarClass = '';
    } else if (this._themeSettingsConfig.colorTheme === 'dark') {
      this.selectedHeaderNavBarClass = this._themeSettingsConfig.menuColor;
      this.selectedNavBarHeaderClass = '';
    } else if (this._themeSettingsConfig.colorTheme === 'light') {
      this.selectedHeaderNavBarClass = this._themeSettingsConfig.menuColor;
      this.selectedNavBarHeaderClass = this._themeSettingsConfig.menuColor;
    }
    if (menuColorElement) {
      if (this._themeSettingsConfig.menuColor === 'menu-dark') {
        this._renderer.removeClass(menuColorElement.item(0), 'menu-light');
        this._renderer.addClass(menuColorElement.item(0), 'menu-dark');
      } else if (this._themeSettingsConfig.menuColor === 'menu-light') {
        this._renderer.removeClass(menuColorElement.item(0), 'menu-dark');
        this._renderer.addClass(menuColorElement.item(0), 'menu-light');
      }
    }

    if (themeColorElement) {
      if (this._themeSettingsConfig.colorTheme === 'semi-light') {
        this._renderer.removeClass(themeColorElement.item(0), 'navbar-semi-dark');
        this._renderer.removeClass(themeColorElement.item(0), 'navbar-dark');
        this._renderer.removeClass(themeColorElement.item(0), 'navbar-light');
      } else if (this._themeSettingsConfig.colorTheme === 'semi-dark') {
        this._renderer.removeClass(themeColorElement.item(0), 'navbar-semi-light');
        this._renderer.removeClass(themeColorElement.item(0), 'navbar-dark');
        this._renderer.removeClass(themeColorElement.item(0), 'navbar-light');
      } else if (this._themeSettingsConfig.colorTheme === 'dark') {
        this._renderer.removeClass(themeColorElement.item(0), 'navbar-semi-dark');
        this._renderer.removeClass(themeColorElement.item(0), 'navbar-semi-dark');
        this._renderer.removeClass(themeColorElement.item(0), 'navbar-light');
      } else if (this._themeSettingsConfig.colorTheme === 'light') {
        this._renderer.removeClass(themeColorElement.item(0), 'navbar-semi-dark');
        this._renderer.removeClass(themeColorElement.item(0), 'navbar-dark');
        this._renderer.removeClass(themeColorElement.item(0), 'navbar-semi-light');
      }
    }

    if (navigationElement) {
      if (this._themeSettingsConfig.navigation === 'menu-native-scroll') {
        this._renderer.addClass(navigationElement.item(0), 'menu-native-scroll');
      } else if (this._themeSettingsConfig.navigation === 'menu-icon-right') {
        this._renderer.addClass(navigationElement.item(0), 'menu-icon-right');
      } else if (this._themeSettingsConfig.navigation === 'menu-bordered') {
        this._renderer.addClass(navigationElement.item(0), 'menu-bordered');
      } else if (this._themeSettingsConfig.navigation === 'menu-flipped') {
        this._renderer.addClass(document.body, 'menu-flipped');
      } else if (this._themeSettingsConfig.navigation === 'menu-collapsible') {
        this._renderer.addClass(navigationElement.item(0), 'menu-collapsible');
      } else if (this._themeSettingsConfig.navigation === 'menu-static') {
        this._renderer.addClass(navigationElement.item(0), 'menu-static');
      }
    }

    if (navbarElement) {
      if (this._themeSettingsConfig.menu === 'navbar-static-top') {
        this._renderer.addClass(navbarElement.item(0), 'navbar-static-top');
        this._renderer.addClass(navigationElement.item(0), 'menu-static');
      }
    }

    if (navbarElement) {
      if (this._themeSettingsConfig.menu === 'semi-light') {
        this._renderer.addClass(navbarElement.item(0), 'navbar-semi-light bg-gradient-x-grey-blue');
      } else if (this._themeSettingsConfig.menu === 'semi-dark') {
        this._renderer.addClass(navbarElement.item(0), 'navbar-semi-dark');
      } else if (this._themeSettingsConfig.menu === 'dark') {
        this._renderer.addClass(navbarElement.item(0), 'navbar-dark');
      } else if (this._themeSettingsConfig.menu === 'light') {
        this._renderer.addClass(navbarElement.item(0), 'navbar-light');
      }
    }
  }

  resetOpenMenu() {
    for (let i = 0; i < this._menuSettingsConfig.vertical_menu.items.length; i++) {
      const menu = this._menuSettingsConfig.vertical_menu.items[i];
      if (!menu.submenu) {
        menu['isOpen'] = false;
        menu['isActive'] = false;
        menu['hover'] = false;
      } else if (menu.submenu) {
        for (let j = 0; j < menu.submenu.items.length; j++) {
          menu['isOpen'] = false;
          menu['isActive'] = false;
          menu['hover'] = false;
          menu.submenu.items[j]['isOpen'] = false;
        }
      }
    }
  }

  setOpenInNavbar(value) {
    for (let i = 0; i < this._menuSettingsConfig.vertical_menu.items.length; i++) {
      const menu = this._menuSettingsConfig.vertical_menu.items[i];
      if (!menu.submenu &&
        menu.page === this.router.url) {
        menu['isOpen'] = value;
        menu['isActive'] = value;
      } else if (menu.submenu) {
        for (let j = 0; j < menu.submenu.items.length; j++) {
          if (menu.submenu.items[j].page === this.router.url) {
            menu['isOpen'] = value;
            menu['isActive'] = value;
            menu.submenu.items[j]['isOpen'] = value;
            menu.submenu.items[j]['isActive'] = value;
            break;
          }
        }
      }
    }
  }

  /**
   * Use for fixed left aside menu, to show menu on mouseenter event.
   * @param e Event
   */
  mouseEnter() {
    if (this.navbarService.isFixedMenu()) {
      return;
    }
    this.navbarService.setMouseInRegion(true);
    const navBar = this.document.getElementById('navbar-header');
    const mainMenu = this.document.getElementById('main-menu');

    // check if the left aside menu is fixed
    if (!navBar.classList.contains('expanded')) {
      this._renderer.addClass(navBar, 'expanded');
      this._renderer.addClass(mainMenu, 'expanded');
      this.resetOpenMenu();
      this.setOpenInNavbar(true);
    }
  }

  handleCollapseOfMenu(element) {
    if (element.classList && element.classList.contains('has-sub') && element.classList.contains('open')) {
      element.classList.remove('open');
      element.classList.remove('hover');
      element.classList.add('menu-collapsed-open');
    }
  }

  handleExpandOfMenu(element) {
    if (element.classList && element.classList.contains('has-sub') &&
      element.classList.contains('menu-collapsed-open')) {
      element.classList.remove('menu-collapsed-open');
      element.classList.add('open');
      element.classList.add('hover');
    }
  }

  toggleMenu(event) {
    const target = event.target || event.srcElement || event.currentTarget;
    const parent = target.parentElement;
    if (parent && parent.classList.contains('has-sub')) {
      this.openSubMenuUsingParent(parent);
    } else {
      const parentOfParent = parent.parentElement;
      this.openSubMenuUsingParent(parentOfParent);
    }
  }

  openSubMenuUsingParent(parent) {
    if (parent.classList && parent.classList.contains('has-sub') &&
      !parent.classList.contains('open')) {
      parent.classList.add('open');
    } else if (parent.classList && parent.classList.contains('has-sub') &&
      parent.classList.contains('open')) {
      parent.classList.remove('open');
    }
  }

  toggleFullScreen() {
    const toggleIcon = document.getElementsByClassName('ficon');

    if (toggleIcon.item(0).classList.contains('ft-maximize')) {
      this.openfullscreen();
      this._renderer.removeClass(toggleIcon.item(0), 'ft-maximize');
      this._renderer.addClass(toggleIcon.item(0), 'ft-minimize');
    } else if (toggleIcon.item(0).classList.contains('ft-minimize')) {
      this.closefullscreen();
      this._renderer.addClass(toggleIcon.item(0), 'ft-maximize');
      this._renderer.removeClass(toggleIcon.item(0), 'ft-minimize');
    }
  }

  // openfullscreen() {
  //   // Trigger fullscreen
  //   // eslint-disable-next-line no-shadow,@typescript-eslint/no-shadow
  //   const docElmWithBrowsersFullScreenFunctions = document.documentElement as HTMLElement & {
  //     mozRequestFullScreen(): Promise<void>;
  //     webkitRequestFullscreen(): Promise<void>;
  //     msRequestFullscreen(): Promise<void>;
  //   };

  //   if (docElmWithBrowsersFullScreenFunctions.requestFullscreen) {
  //     docElmWithBrowsersFullScreenFunctions.requestFullscreen();
  //   } else if (docElmWithBrowsersFullScreenFunctions.mozRequestFullScreen) { /* Firefox */
  //     docElmWithBrowsersFullScreenFunctions.mozRequestFullScreen();
  //   } else if (docElmWithBrowsersFullScreenFunctions.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
  //     docElmWithBrowsersFullScreenFunctions.webkitRequestFullscreen();
  //   } else if (docElmWithBrowsersFullScreenFunctions.msRequestFullscreen) { /* IE/Edge */
  //     docElmWithBrowsersFullScreenFunctions.msRequestFullscreen();
  //   }
  // }

  // closefullscreen() {
  //   // eslint-disable-next-line no-shadow, @typescript-eslint/no-shadow
  //   const docWithBrowsersExitFunctions = document as Document & {
  //     mozCancelFullScreen(): Promise<void>;
  //     webkitExitFullscreen(): Promise<void>;
  //     msExitFullscreen(): Promise<void>;
  //   };
  //   if (docWithBrowsersExitFunctions.exitFullscreen) {
  //     docWithBrowsersExitFunctions.exitFullscreen();
  //   } else if (docWithBrowsersExitFunctions.mozCancelFullScreen) { /* Firefox */
  //     docWithBrowsersExitFunctions.mozCancelFullScreen();
  //   } else if (docWithBrowsersExitFunctions.webkitExitFullscreen) { /* Chrome, Safari and Opera */
  //     docWithBrowsersExitFunctions.webkitExitFullscreen();
  //   } else if (docWithBrowsersExitFunctions.msExitFullscreen) { /* IE/Edge */
  //     docWithBrowsersExitFunctions.msExitFullscreen();
  //   }

  // }

  toggleFixMenu() {
    if (this.document.body.classList.contains('menu-expanded')) {
      // show the left aside menu
      this.navbarService.setFixedMenu(false);
      this.document.body.classList.remove('menu-expanded');
      this.document.body.classList.add('menu-collapsed');
      // Change switch icon
      this._themeSettingsConfig.menu = 'collapse';
    } else {
      this.navbarService.setFixedMenu(true);
      this.document.body.classList.remove('menu-collapsed');
      this.document.body.classList.add('menu-expanded');
      // Change switch icon
      this._themeSettingsConfig.menu = 'expand';
    }
    const navBar = this.document.getElementById('navbar-header');
    const mainMenu = this.document.getElementById('main-menu');
   

    if (navBar && mainMenu) {
      this._renderer.addClass(navBar, 'expanded');
      this._renderer.addClass(mainMenu, 'expanded');
    }
   
    setTimeout(() => { AppConstants.fireRefreshEventOnWindow(); }, 300);
  }

  toggleNavigation() {
    const sidenav = document.getElementById('sidenav-overlay');
    const sidebarLeft = document.getElementById('sidebar-left') || document.getElementById('email-app-menu') ||
      document.getElementById('sidebar-todo');
    const contentOverlay = document.getElementById('content-overlay');

    if (this.document.body.classList.contains('menu-open') && (this.router.url === '/todos' || this.router.url === '/contacts' ||
      this.router.url === '/email' || this.router.url === '/chats' || this.router.url === '/chats/static-chat')) {
      this.document.body.classList.remove('menu-open');
      this._renderer.removeClass(sidenav, 'd-block');
      this._renderer.removeClass(contentOverlay, 'show');
      this.document.body.classList.add('menu-close');
      this._renderer.addClass(sidenav, 'd-none');
      this.showNavbar = false;
    } else if (this.document.body.classList.contains('menu-open')) {
      this.document.body.classList.remove('menu-open');
      this._renderer.removeClass(sidenav, 'd-block');
      this.document.body.classList.add('menu-close');
      this._renderer.addClass(sidenav, 'd-none');
      this.showNavbar = false;
    } else {
      this._renderer.removeClass(sidenav, 'd-none');
      this.document.body.classList.remove('menu-close');
      this.document.body.classList.add('menu-open');
      this._renderer.addClass(sidenav, 'd-block');
      this.showNavbar = false;
    }

    if (sidebarLeft) {
      this._renderer.removeClass(sidebarLeft, 'show');
    }
    if (contentOverlay) {
      this._renderer.removeClass(contentOverlay, 'show');
    }
  }

  toggleNavbar() {
    if (this.showNavbar) {
      this.showNavbar = false;
    } else {
      this.showNavbar = true;
    }
  }

  public clickSearch() {
    if (this.isHeaderSearchOpen) {
      this.isHeaderSearchOpen = false;
    } else {
      this.isHeaderSearchOpen = true;
    }
  }

  /**
   * Use for fixed left aside menu, to show menu on mouseenter event.
   * @param e Event
   */
  mouseLeave() {
    if (this.navbarService.isFixedMenu()) {
      return;
    }
    //const _self = this;
    const navBar = this.document.getElementById('navbar-header');
    const mainMenu = this.document.getElementById('main-menu');
    if (navBar && navBar.classList.contains('expanded')) {
      this.insideTm = setTimeout(() => {
        if (!this.navbarService.isMouseInRegion()) {
          this._renderer.removeClass(navBar, 'expanded');
          this._renderer.removeClass(mainMenu, 'expanded');
          this.resetOpenMenu();
          this.setOpenInNavbar(false);
        }
      }, 300);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < AppConstants.MOBILE_RESPONSIVE_WIDTH) {
      this.isMobile = true;
      this.showNavbar = false;
    } else {
      this.isMobile = false;
      this.showNavbar = true;
    }
  }

  @HostListener('document:click', ['$event'])
  public onClick(event: any): void {
    const navBar = this.document.getElementById('navbar-header');
    const mainMenu = this.document.getElementById('main-menu');

    if (event.target.closest('#navbar-header') === null &&
      navBar && navBar.classList.contains('expanded') &&
      !this.navbarService.isFixedMenu()) {
      this._renderer.removeClass(navBar, 'expanded');
      this._renderer.removeClass(mainMenu, 'expanded');
      this.resetOpenMenu();
      this.setOpenInNavbar(false);
    }
  }

  setCurrentProductUId(CurrentProductUId) {
    localStorage.setItem('CurrentProductUId', CurrentProductUId);
  }
  setCurrentClientUId(CurrentClientUId) {
    localStorage.setItem('CurrentClientUId', CurrentClientUId);
  }
}
